export default {
  warning:
    'Dieser Store ist keiner Marke zugeordnet. Damit das System ordnungsgemäß funktioniert, muss der Store einer Marke zugeordnet werden. Bitte ordnen Sie diesen Store einer Marke zu.',
  cta: 'Zu den Marken',
};
